import Axios from "axios";
import Store from "@/store";
import Router from "@/router";
import { snackBarMapError } from "@/utilities/snackbar";
import i18n from "@/i18n";

const baseURL =
  process.env.NODE_ENV === "development" ? "http://localhost:8000" : "";
const axiosConfig = {
  baseURL: baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 60000,
};

const axiosClient = Axios.create(axiosConfig);

axiosClient.interceptors.request.use((config) => {
  const token = Store.state.user.userToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(error);
    const errorPayload = snackBarMapError(error);

    if (errorPayload.code === 401) {
      Store.dispatch("user/resetState");
      if (
        !["auth.login", "auth.login.firm"].includes(Router.currentRoute.name)
      ) {
        Router.push({ name: "auth.login" });
      } else {
        errorPayload.message = i18n.t("wrong-credentials");
      }
    } else if (errorPayload.code === 403) {
      Router.push({ name: "dashboard" });
    }

    Store.dispatch("snackbar/setSnackbar", errorPayload);
    return Promise.reject(error);
  }
);

export { axiosClient };
